//booking widget variables
var start = document.getElementById('arriveInput').value;
var end = document.getElementById('departureInput').value;
var opened = 0;
var opencheck;



// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

	

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');


		/*let allBtn = document.querySelectorAll(".btn");
		allBtn.forEach( (elm) => {
			let words = elm.outerText.split(" ");
			words[0] = '<span>'.concat(words[0] , '</span>');
			elm.innerHTML = words.join(' ');
		})*/

		//Booking open functionality
		let btnBooking = document.querySelector(".js-booking-cta");
		let bookingContainer = document.getElementById("bookingBox");
		let btnClose = document.getElementById('closeBooking');

		btnBooking.addEventListener('click' , (e)=>{
			e.preventDefault();
			bookingContainer.classList.add('open');
		});

		btnClose.addEventListener('click' , ()=>{
			bookingContainer.classList.remove('open');
		});

		//Burger menu functionality
		let btnBurger = document.getElementById("burgerMenu");
		let btnBurgerMobile = document.getElementById("burgerMenuMobile");
		let containerNavigation = document.querySelector(".container-navigation");
		let closeNavigation = document.getElementById('close-navigation');


		btnBurgerMobile.addEventListener('click' , ()=>{
			containerNavigation.classList.add('open');
		});

		btnBurger.addEventListener('click' , ()=>{
			containerNavigation.classList.add('open');
		});
		closeNavigation.addEventListener('click' , ()=>{
			containerNavigation.classList.remove('open');
		});

		//change copy disneyland specials
		let liCopy = document.querySelector('li[data-target="disneyland"');
		if(liCopy){
			liCopy.innerHTML = '<span>Disneyland®  </span> Resort Packages';
		}
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/** BOOKING WIDGET FUNCTIONALITY */


$(document).ready(function () {

	//To create after event 
	$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
	$.datepicker._updateDatepicker = function (inst) {
		$.datepicker._updateDatepicker_original(inst);
		var afterShow = this._get(inst, 'afterShow');
		if (afterShow)
			afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
	}
	$('#arriveInput').on('change', function(){
		start = $(this).val();
		$('.calendar-block').datepicker("setDate", start)
	})
	$('#departureInput').on('change', function(){
		end = $(this).val();
		$('.calendar-block').datepicker("setDate", end)
	})
	//alert($('#arriveInput').val());
	let fullMonths = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
	$('.calendar-block').datepicker({
		changeMonth: false,
		dateFormat: 'mm-dd-yy',
		numberOfMonths: 2,
		monthNamesShort: fullMonths,
		//altField: "#arriveInput",
		//altFormat: "mm-dd-yy",
		beforeShowDay: function (date) { 

			$.datepicker._defaults.dateFormat = "mm-dd-yy";
			var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
			var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
			if (date.getTime() == startDate.getTime()) {
				return [true, "startday"];
			} else {
				if (date.getTime() == endDate.getTime()) {
					return [true, "endday"];
				} else {
					if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
						return [true, "days"];
					} else {
						return [true, ""];
					}
				}
			}
		},
		onSelect: function (date) {
			var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
			var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
			var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

			if (opened == 0) {
				opened = 1;
				start = date;
				end = date;
				opencheck = 0;
			} else {
				opened = 0;
				if (selectedDate <= arrive) {
					end = start;
					start = date;
				} else {
					end = date;
				}
			
				
			}

			$('#arriveInput').attr('value', start);
			$('#departureInput').attr('value', end);
		
		},
		onChangeMonthYear: function () {
			opencheck = 1;
		}
	});


});
